const topics = [
  { name: '#暑期档', count: '12.8万讨论', icon: 'ri-sun-line' },
  { name: '#国产悬疑', count: '9.6万讨论', icon: 'ri-search-eye-line' },
  { name: '#4K画质', count: '8.2万讨论', icon: 'ri-4k-line' },
  { name: '#韩剧推荐', count: '7.5万讨论', icon: 'ri-heart-pulse-line' },
  { name: '#动画电影', count: '6.9万讨论', icon: 'ri-emotion-happy-line' },
  { name: '#经典港片', count: '6.3万讨论', icon: 'ri-movie-line' },
  { name: '#综艺爆笑', count: '5.8万讨论', icon: 'ri-emotion-laugh-line' },
  { name: '#追剧神器', count: '5.2万讨论', icon: 'ri-smartphone-line' },
  { name: '#周末片单', count: '4.7万讨论', icon: 'ri-calendar-check-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">大家都在讨论的影视热点，一起来参与</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group flex flex-col items-center p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all cursor-pointer no-underline"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-2.5 group-hover:bg-accent-200 transition-colors">
                <i className={`${topic.icon} text-base`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-400 mt-1">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}